import React from "react";
import { Link } from "react-router-dom";
import links from "./data";
import NewHeader from "../../../Layouts/NewHeader";
import NewFooter from "../../../Layouts/NewFooter";

const AboutUs = () => {
  return (
    <>
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh", overflowX: "hidden" }}
      >
        <NewHeader />
        <div
          className="container"
          style={{ flex: "1",paddingTop: "20px" }}
        >
          <div
            style={{
              fontSize: "18px",
              paddingTop: "10px",
            }}
            className="card px-3 py-5 my-3 m-auto shadow-lg mt-2"
          >
            <h4
              className="text-center mt-4"
              style={{ color: "#212529", fontSize: "34px" }}
            >
              About Us
            </h4>
            <p
              style={{
                marginLeft: "30px",
                marginRight: "30px",
                textAlign: "justify",
                fontSize: "16px",
              }}
              className=" my-3"
            >
              Department of Power, Government of Nagaland is responsible for
              Generation, Transmission and Distribution of Electricity
              throughout the state. In order to improve the electricity revenue,
              the state Government has started introducing Prepaid Electricity
              Meters in the main load centres of Kohima and Dimapur.
            </p>
            <p
              style={{
                marginLeft: "30px",
                marginRight: "30px",
                fontSize: "16px",
              }}
              className="text-justify my-3"
            >
              This initiative, in collaboration with M/S Universal Power
              Solutions, aims to reduce the AT&C Losses significantly, increase
              state revenue and deliver better service to the consumer.
            </p>
          </div>
        </div>
        <NewFooter />
      </div>
    </>
  );
};

export default AboutUs;
